export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8262.922f8722.jpg";